export const focusManagementHelper = {
    restoreListFocus: (listClassName: string, focusIndex: number, focusableChildClassName?: string): void => {
        if (focusIndex < 0) {
            return;
        }
        const listItem = (Array.from(document.querySelectorAll('.' + listClassName + ' > li')) as HTMLElement[])[focusIndex];
        if (focusableChildClassName) {
            // (listItem.querySelector('.' + focusableChildClassName) as HTMLElement).focus();
            focusManagementHelper.restoreElementFocus(listItem, focusableChildClassName);
        } else {
            listItem.focus();
        }
    },
    restoreElementFocus: (element: HTMLElement, elementClassName: string): boolean => {
        const elem = element.querySelector('.' + elementClassName) as HTMLElement;
        if (elem) {
            elem.focus();
            return true;
        } else {
            return false;
        }
    }
};
